import React, { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import FolderIcon from '@mui/icons-material/Folder';
import { Button, ClickAwayListener } from '@mui/material';
import { CustomerTreeView } from './CustomerTreeView';
import { FolderItem } from '../../../../../types/graph';
import { FormattedMessage } from 'react-intl';

interface CustomerTreeViewPopperProps {
	onCustomerSelect?: (customerName: string) => void;
	onFileSelect?: (file: FolderItem) => void;
	buttonText?: string;
	hasItems?: boolean;
}

export const CustomerTreeViewPopper: React.FC<CustomerTreeViewPopperProps> = ({ onCustomerSelect, onFileSelect, hasItems = false }) => {
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(anchorEl ? null : event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);

	return (
		<ClickAwayListener onClickAway={handleClose}>
			<div style={{ position: 'relative', zIndex: 9999 }}>
				<Button
					onClick={handleClick}
					variant='text'
					startIcon={open ? <CloseIcon /> : <FolderIcon />}
					aria-expanded={Boolean(anchorEl)}
					aria-haspopup='true'
				>
					<FormattedMessage id='customerTreeView.buttonText' />
				</Button>
				<CustomerTreeView
					onCustomerSelect={customerName => {
						if (onCustomerSelect) {
							onCustomerSelect(customerName);
						}
					}}
					onFileSelect={file => {
						if (onFileSelect) {
							onFileSelect(file);
							handleClose();
						}
					}}
					anchorEl={anchorEl}
					onClose={handleClose}
				/>
			</div>
		</ClickAwayListener>
	);
};
